// src/pages/AuthCallback.js
import React, {useState} from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {Box, Text, Button, useToast, HStack, Center, useDisclosure} from "@chakra-ui/react";
import axios from "axios";
import {useServerIP} from "../../../redux/ServerIPContext";
import SignUpScreen1 from "./SignUpScreen1";

const ERRORS = {
    deleted_account:
        "The account with this email was deleted by the user. We prevent deleted accounts from signing up again. Please email contact@honeybear.ai if you have questions.",
    no_code: "No authorization code received from Google. Please try again.",
    token_failed: "Failed to fetch token from Google. Please try again.",
    userinfo_failed: "Could not retrieve your Google profile. Please try again.",
    api_exception: "An error occurred calling Google’s API. Please try again.",
    no_email: "Google did not return your email address. Please try again.",
    no_name: "Oops, Google didn't return us your name. Use the manual sign-up option instead by typing in your first/last name and email.",
    db_error: "A database error occurred. Please try again later.",
    user_creation_failed: "Could not create your account. Please retry.",
    auth_failed:
        "Authentication failed due to an unexpected error. Please try again.",
    access_denied: "Access denied. You must allow access to your Google account.",
};

export default function AuthCallback() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const err = params.get("error");
    const msg = ERRORS[err] || "An unknown error occurred.";
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const { serverIPs, setServerIPs, isDev } = useServerIP();
    // const { isOpen: isOpenSignUpScreen1, onOpen: onOpenSignUpScreen1, onClose: onCloseSignUpScreen1 } = useDisclosure();
    // const { isOpen: isOpenSignInScreen1, onOpen: onOpenSignInScreen1, onClose: onCloseSignInScreen1 } = useDisclosure();

    const handleSignIn = async () => {
        setLoading(true);
        try {
            const response = await axios.post(serverIPs.SERVER_IP + '/signin_with_google', {
            });

            console.log("Response from Google sign-in endpoint:", response)
            if (response.data.status !== 200) {
                toast({
                    title: "Google Sign-In failed",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
                setLoading(false);
            } else {
                const authorization_url = response.data.message.authorization_url;
                const state = response.data.message.state;
                console.log("GOT HERE AUTHORIZATION URL", authorization_url);
                window.location.href = authorization_url;
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
            toast({
                title: "Google Sign-In failed",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
            setLoading(false);
        }
    };

    return (
        <Center>
            <Box p={6} textAlign="center" alignItems={'center'} display={'flex'} flexDirection={'column'} px={10}>
                <Text fontSize="2xl" fontWeight="bold">
                    Sign-in With Google Error
                </Text>
                <Text mt={4}>{msg}</Text>
                {/*<HStack mt={6} spacing={5}>*/}
                {/*    <Button onClick={() => navigate("/")}>*/}
                {/*        Visit Home*/}
                {/*    </Button>*/}
                {/*    <Button*/}
                {/*        isLoading={loading}*/}
                {/*        onClick={handleSignIn}*/}
                {/*        colorScheme="blue">*/}
                {/*        Try Again*/}
                {/*    </Button>*/}
                {/*</HStack>*/}





                <HStack spacing={6} mt={7}>
                    <Button
                        size="lg"
                        bg={'gray.200'} color={'gray.800'}
                        onClick={() => {
                            navigate("/");
                            // onOpenSignUpScreen1();
                        }}
                        _hover={{
                            boxShadow: 'xl',
                        }}
                    >
                        Visit Home
                    </Button>
                    {
                        err !== "deleted_account" ?
                            <Button
                                loadingText="Trying again..."
                                size="lg"
                                isLoading={loading}
                                onClick={handleSignIn}
                                bgGradient="linear(to-r, red.400,pink.400)"
                                color={'white'}
                                _hover={{
                                    bgGradient: 'linear(to-r, red.400,pink.400)',
                                    boxShadow: 'xl',
                                }}>
                                Try Again
                            </Button> : null
                    }
                </HStack>
            </Box>
            {/*<SignUpScreen1 isOpenSignUpScreen1={isOpenSignUpScreen1} onCloseSignUpScreen1={onCloseSignUpScreen1} onOpenSignInScreen1={onOpenSignInScreen1}/>*/}
        </Center>
    );
}
